import React from 'react'

function Download() {
  return (
    <div>Download</div>
  )
}

export default Download